import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { KeycloakService } from '@inoventoryapps/keycloak-angular';
import { catchError, forkJoin, of } from 'rxjs';
import { CdnService } from '../_services/_cdn/cdn.service';
import { UserService } from '../_services/_user/user.service';

@Injectable({
    providedIn: 'root',
})
export class RolesConfigResolverService implements Resolve<any> {
    constructor(
        private keycloakService: KeycloakService,
        private userService: UserService,
        private cdnService: CdnService
    ) {}

    resolve() {
        const req1 = this.keycloakService.loadUserInfo();
        const req2 = this.userService
            .getUserProfileImage()
            .pipe(catchError(() => of(null)));
        const req3 = this.cdnService.getGeoLocationMaping();
        const req4 = this.cdnService.getClientIdsMaping();
        return forkJoin([req1, req2, req3, req4]);
    }
}
